<div *ngIf="offerNumber">
    <span class="send-offer__title">
        {{offerNumberService.numberLabel | translate}}: &nbsp;
    </span>
    <span class="send-offer__number">
        {{offerNumber}}
    </span>
</div>
<div *ngIf="quotationId" class="send-offer__quotation-id">
    <span class="send-offer__title">
        {{'SEND-OFFER_COMPONENT.quotationId' | translate}}: &nbsp;
    </span>
    <span class="send-offer__number">
        {{quotationId}}
    </span>
</div>
